import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const MONTHS = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
];

/*
    -----------------------------------------------------------------------------
    🔥 CABECERA ÚNICA DEL DATEPICKER
    -----------------------------------------------------------------------------
    🎯 Evita la navegación nativa/absoluta de react-datepicker, que en algunos
       anchos terminaba superpuesta al texto del mes. Las flechas viven en sus
       propias columnas y el mes/año queda siempre legible y centrado.
    -----------------------------------------------------------------------------
*/
export const DatePickerHeader = ({
    date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled,
}) => (
    <div className="LS__dp_header_nav">
        <button type="button" className="LS__dp_header_btn" aria-label="Mes anterior"
            onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
            <FaChevronLeft />
        </button>

        <span className="LS__dp_header_label">
            {MONTHS[date.getMonth()]} {date.getFullYear()}
        </span>

        <button type="button" className="LS__dp_header_btn" aria-label="Mes siguiente"
            onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
            <FaChevronRight />
        </button>
    </div>
);
